import { render, staticRenderFns } from "./LandingPage.vue?vue&type=template&id=734da04c&scoped=true&"
import script from "./LandingPage.vue?vue&type=script&lang=js&"
export * from "./LandingPage.vue?vue&type=script&lang=js&"
import style0 from "./LandingPage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./LandingPage.vue?vue&type=style&index=1&id=734da04c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734da04c",
  null
  
)

export default component.exports